import React from 'react';
import { connect } from 'react-redux';

import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonTimeZone } from 'selectors/currentSalon.selectors';
import { selectTimeOffData } from 'selectors/timeoff.selectors';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import { formatHourAndMinuteShortMeridiem } from 'utils/date/format.util';
import zonedMoment from 'utils/date/zonedMoment.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import MiniModal from 'scheduler/components/MiniModal';

const WRAPPER_STYLE = Object.freeze({ height: '24px', width: '100%' });
const ENTRY_STYLE = Object.freeze({ height: '24px' });

const L = logger('NewEntryPlaceholder');

const NewEntryPlaceholder = ({ schedulerTime, tz, toffData, t, ...extra }) => {
  const { startTime } = asObject(toffData);

  const currentTime = startTime || zonedMoment(tz, schedulerTime);
  const displayTime = formatHourAndMinuteShortMeridiem(currentTime);

  L.debug('()', startTime, fromAnyDateToIso(schedulerTime), displayTime);

  return (
    <div data-bem="NewEntryPlaceholder" className="cal-container" data-cy="new-entry-placeholder">
      <MiniModal currentTime={currentTime} {...extra} />
      <div data-bem="NewEntryPlaceholder__wrap" className="cal-entry-wrap cal-state-bg-a mini-modal" style={WRAPPER_STYLE}>
        <div data-bem="NewEntryPlaceholder__calendar-entry" className="cal-entry" style={ENTRY_STYLE}>
          <div data-bem="NewEntryPlaceholder__calendar-client" className="cal-client">
            <div data-bem="NewEntryPlaceholder__calendar-time" className="cal-time">
              {displayTime}
            </div>
            <div data-bem="NewEntryPlaceholder__calendar-name" className="cal-name cal-txt-b">
              <span>{t('common.buttons.newUpp')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  tz: selectCurrentSalonTimeZone(state),
  toffData: selectTimeOffData(state),
});

const NewEntryPlaceholderHoc = connect(mapStateToProps)(withTranslation()(NewEntryPlaceholder));

export default NewEntryPlaceholderHoc;
